import type { DownloadableContent } from "@/entities/downloadable-content";
import { getDownloadUrl } from "@/features/downloadable-content";

interface WorksheetCardProps {
  worksheet: DownloadableContent;
}

/**
 * WorksheetCard - 워크지 카드 컴포넌트
 * DownloadableContent 데이터를 받아 표시합니다
 */
export const WorksheetCard = ({ worksheet }: WorksheetCardProps) => {
  const handleDownload = async () => {
    try {
      const url = await getDownloadUrl(worksheet.id);
      window.open(url, "_blank");
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  return (
    <div className="w-80 flex flex-col gap-10">
      <div className="w-80 h-80 p-6 bg-neutral-100 rounded-3xl flex justify-end items-end border border-black/5 overflow-hidden relative">
        {/* 썸네일 이미지 */}
        {worksheet.thumbnail_file && (
          <img
            src={
              worksheet.thumbnail_file.thumbnail_url ||
              worksheet.thumbnail_file.s3_path
            }
            alt={worksheet.title}
            className="absolute inset-0 w-full h-full object-cover"
          />
        )}
        {/* 다운로드 버튼 */}
        <button
          onClick={handleDownload}
          className="relative z-10 p-3 bg-orange-500 rounded-full hover:bg-orange-600 transition-colors flex justify-center items-center"
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15.5907 10L13.005 12.5857V3C13.005 2.96548 13.0032 2.93137 12.9998 2.89776C12.9486 2.3935 12.5227 2 12.005 2C11.4527 2 11.005 2.44772 11.005 3V12.5857L8.41917 9.99994C8.02865 9.60945 7.39548 9.60945 7.00496 9.99994C6.61443 10.3905 6.61443 11.0236 7.00496 11.4142L11.2979 15.7071C11.4854 15.8946 11.7398 16 12.005 16C12.2702 16 12.5245 15.8946 12.7121 15.7071L17.005 11.4142C17.0538 11.3654 17.0965 11.3128 17.1331 11.2573C17.3894 10.8692 17.3467 10.3417 17.005 10C16.6144 9.60949 15.9813 9.60949 15.5907 10Z"
              fill="white"
            />
            <path
              d="M4.00488 14.0001C4.55717 14.0001 5.00488 14.4478 5.00488 15.0001V19.0001H19.0049V15.0001C19.0049 14.4478 19.4526 14.0001 20.0049 14.0001C20.5572 14.0001 21.0049 14.4478 21.0049 15.0001V19.0001C21.0049 20.1047 20.1095 21.0001 19.0049 21.0001H5.00488C3.90031 21.0001 3.00488 20.1047 3.00488 19.0001V15.0001C3.00488 14.4478 3.4526 14.0001 4.00488 14.0001Z"
              fill="white"
            />
          </svg>
        </button>
      </div>
      <div className="w-72 flex flex-col gap-4">
        <h4 className="text-xl font-normal text-black">{worksheet.title}</h4>
        <p className="text-lg font-light text-black leading-7">
          {worksheet.description}
        </p>
      </div>
    </div>
  );
};
